import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { useAxiosDiagnosis } from "../../axios";

export const useDeleteCandidateDraftDiagnosis = () => {
  const [state, execute, cancel] = useAxiosDiagnosis<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId) =>
      execute({
        url: `/draft/candidate/${candidateId}`,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
